import React from "react";

const ProductHighlightView = ({ filesNew, filesDescsNew, productDetail, productHighlights, media_types, content_types }) => {
  const genFileIndex = (file) => {
    const name = file.fileName || file.name || file.file_name;
    return name.split(" ").join("");
  };

  return (
    <div>
      <div className="my-3 px-2">
        <i className="fa fa-camera" /> Product Banner Highlight
      </div>

      {filesNew?.length === 0 && (
        <div className="my-5 text-center">
          <p className="text-muted">No banner highlight available</p>
        </div>
      )}

      <div className="row">
        {filesNew?.map((file, index) => {
          let fileIndex = genFileIndex(file);
          if (!filesNew[fileIndex] && file.fileIndex) fileIndex = file.fileIndex;

          return (
            <div className="col-md-4 mb-3" key={index}>
              <div className="d-flex align-items-center">
                <div style={{ width: "50%", height: 200 }}>
                  <img
                    src={file.url}
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "100%",
                      borderRadius: 4,
                      marginBottom: 20,
                      cursor: "pointer",
                    }}
                  />
                </div>
                <div className="mx-3">
                  <div>
                    <div className="text-secondary">Description</div>
                    <p>{filesDescsNew[fileIndex]?.media_desc || "-"}</p>
                  </div>
                  <div className="mb-3">
                    <div className="text-secondary">Image Types</div>
                    {filesDescsNew[fileIndex]?.media_types?.map((item) => {
                      const mediaType = media_types.find((type) => type.code === item);
                      return (
                        <div key={item} className="badge badge-warning mr-1">
                          {mediaType ? mediaType.name : item}
                        </div>
                      );
                    })}
                  </div>
                  <div>
                    <div className="text-secondary">Content Types</div>
                    {filesDescsNew[fileIndex]?.content_types?.map((item) => {
                      const contentType = content_types.find((type) => type.code === item);
                      return (
                        <div key={item} className="badge badge-warning mr-1">
                          {contentType ? contentType.name : item}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="dropdown-divider" />

      <div className="mt-3">
        {productHighlights?.map((item, idx) => {
          const showWithSameLanguage = item.language_code == productDetail.language_code;

          return (
            <div key={idx}>
              {showWithSameLanguage && (
                <div className="row">
                  <div className="col-md-6">
                    <div className="text-secondary">Highlight Name</div>
                    <p className="text-break" style={{ whiteSpace: "pre-wrap" }}>
                      {item.title || "-"}
                    </p>
                  </div>
                  <div className="col-md-6">
                    <div className="text-secondary">Highlight Description</div>
                    <p className="text-break" style={{ whiteSpace: "pre-wrap" }}>
                      {item.description || "-"}
                    </p>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductHighlightView;
